/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeprecatedMeteringPointFromJSON, DeprecatedMeteringPointToJSON, } from './DeprecatedMeteringPoint';
import { CustomerBasicFromJSON, CustomerBasicToJSON, } from './CustomerBasic';
import { LineItemFromJSON, LineItemToJSON, } from './LineItem';
/**
 * Check if a given object implements the DeprecatedPointInvoiceAddendum interface.
 */
export function instanceOfDeprecatedPointInvoiceAddendum(value) {
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined)
        return false;
    if (!('invoiceId' in value) || value['invoiceId'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined)
        return false;
    if (!('paymentDeadline' in value) || value['paymentDeadline'] === undefined)
        return false;
    if (!('totalCost' in value) || value['totalCost'] === undefined)
        return false;
    if (!('vat' in value) || value['vat'] === undefined)
        return false;
    if (!('totalCostWithVat' in value) || value['totalCostWithVat'] === undefined)
        return false;
    if (!('totalInvoiceCost' in value) || value['totalInvoiceCost'] === undefined)
        return false;
    if (!('totalInvoiceCostWords' in value) || value['totalInvoiceCostWords'] === undefined)
        return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined)
        return false;
    if (!('meteringPoint' in value) || value['meteringPoint'] === undefined)
        return false;
    if (!('meteringPointsCount' in value) || value['meteringPointsCount'] === undefined)
        return false;
    return true;
}
export function DeprecatedPointInvoiceAddendumFromJSON(json) {
    return DeprecatedPointInvoiceAddendumFromJSONTyped(json, false);
}
export function DeprecatedPointInvoiceAddendumFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'invoiceNumber': json['invoice_number'],
        'invoiceId': json['invoice_id'],
        'parentId': json['parent_id'],
        'customer': CustomerBasicFromJSON(json['customer']),
        'invoiceDate': (new Date(json['invoice_date'])),
        'paymentDeadline': (new Date(json['payment_deadline'])),
        'totalCost': json['total_cost'],
        'vat': json['vat'],
        'totalCostWithVat': json['total_cost_with_vat'],
        'totalInvoiceCost': json['total_invoice_cost'],
        'totalInvoiceCostWords': json['total_invoice_cost_words'],
        'lineItems': (json['line_items'].map(LineItemFromJSON)),
        'meteringPoint': DeprecatedMeteringPointFromJSON(json['metering_point']),
        'meteringPointsCount': json['metering_points_count'],
    };
}
export function DeprecatedPointInvoiceAddendumToJSON(json) {
    return DeprecatedPointInvoiceAddendumToJSONTyped(json, false);
}
export function DeprecatedPointInvoiceAddendumToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'invoice_number': value['invoiceNumber'],
        'invoice_id': value['invoiceId'],
        'parent_id': value['parentId'],
        'customer': CustomerBasicToJSON(value['customer']),
        'invoice_date': ((value['invoiceDate']).toISOString().substring(0, 10)),
        'payment_deadline': ((value['paymentDeadline']).toISOString().substring(0, 10)),
        'total_cost': value['totalCost'],
        'vat': value['vat'],
        'total_cost_with_vat': value['totalCostWithVat'],
        'total_invoice_cost': value['totalInvoiceCost'],
        'total_invoice_cost_words': value['totalInvoiceCostWords'],
        'line_items': (value['lineItems'].map(LineItemToJSON)),
        'metering_point': DeprecatedMeteringPointToJSON(value['meteringPoint']),
        'metering_points_count': value['meteringPointsCount'],
    };
}
